export const COLOR = '#af2525';
